import React from 'react';
import { Box, Button, Container } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const DataNotFound = () => {
    const navigate = useNavigate();
    
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%", bgcolor: "#ffffff", }} data-model-id="548:1002">
        <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80%", }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "30px", maxWidth: "500px", textAlign: "center", }}>
                <Box component="img" src="/image/notDataFound.png" alt="404 Error Illustration" sx={{ width: "50%", height: "auto", maxHeight: "500px", objectFit: "cover", }} />
                <Button
                    variant="contained"
                    onClick={() => navigate('/dashboard')}
                    sx={{ bgcolor: "#4B49AC",
                        borderRadius: 1, fontFamily: "Poppins, Helvetica", fontWeight: 500, fontSize: "15px",
                        padding: "10px 20px", width: "250px", height: "50px", textTransform: "none",
                    }}
                >
                    Back To Dashboard
                </Button>
            </Box>
        </Container>
    </Box>
    );
};

export default DataNotFound;